import { render, staticRenderFns } from "./WallSponsorsBlockGeneralSettings.vue?vue&type=template&id=262a41df"
import script from "./WallSponsorsBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WallSponsorsBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports